import actions from './actions';
import mutations from './mutations.js';
import getters from './getters.js';


const state = {
    modalConnectWithData: {
        payments_settled: [],
        unallocated_payments: [],
        documents_settled: [],
        documents: [],
        unallocated_documents: [],
        options: [],
        errors: {},
        settlement_date: '',
        description: '',
        currency_exchange: false,
        contractor_ids: [],
        department_ids : [],
    },
    modalConnectWithOptions: {},
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters,
}
